import { useRouter } from 'next/router';

export const useGetNewsFeedFilters = () => {
  const router = useRouter();
  return {
    sportAlias: (router.query.url as string) || '',
  };
};
